import { useSelector } from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { STATUS } from '@app/constants/commonConstants';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { isEmpty } from '@app/utils';
import ProductListMainContent from '../ProductListMainContent';
import ProductListSidebar from '../ProductListSidebar';

const ProductListBody = ({
  handleEquipmentCheck,
  pageDoesntExist,
  espotData
}) => {
  const currentCategory = useSelector(s => s.plpUI.current);
  const facets = useSelector(
    s => s.categories.byId[currentCategory]?.facets || []
  );
  const catalogEntries = useSelector(
    s => s.categories.byId[currentCategory]?.productsId
  );
  const plpDetailsStatus = useSelector(s => s.plpUI.getPlpDetailsStatus);
  const subcategories = useSelector(
    s => s.categories.byId[currentCategory]?.subcategories
  );

  const hasEntries = !isEmpty(catalogEntries);
  const noFacets = isEmpty(facets);
  const noSubcategories = isEmpty(subcategories);
  const didFirstPlpDetailsCallResolve = !!catalogEntries;
  const noDataInResponse =
    !hasEntries &&
    plpDetailsStatus !== STATUS.IDLE &&
    noFacets &&
    noSubcategories;

  return (
    <>
      <ExceptionFeedbackBySelector
        selector={s => s.errors?.[ERROR_DOMAIN.PLP]?.[ERROR_PATH.MAIN]}
        className={cx('mb-4 pb-2', {
          'd-block': noDataInResponse,
          'd-md-block d-none': !noDataInResponse
        })}
        showReferenceId
      />
      <div
        className={cx('row mx-0 mb-3', {
          'd-none':
            !didFirstPlpDetailsCallResolve &&
            plpDetailsStatus === STATUS.REJECTED
        })}
      >
        <ProductListSidebar
          handleEquipmentCheck={handleEquipmentCheck}
          pageDoesntExist={pageDoesntExist}
        />
        <ProductListMainContent
          handleEquipmentCheck={handleEquipmentCheck}
          pageDoesntExist={pageDoesntExist}
          espotData={espotData}
        />
      </div>
    </>
  );
};

ProductListBody.propTypes = {
  handleEquipmentCheck: PropTypes.func,
  pageDoesntExist: PropTypes.bool,
  espotData: PropTypes.arrayOf(PropTypes.string)
};

export default ProductListBody;
